import styles from '../home.module.scss'
import { motion } from "framer-motion"
import { RiLoginCircleLine } from 'react-icons/ri'

export default function Ready({ user, error }: any){
    return (
        <div>
            <div
            className={styles.ready}>
                <motion.div
                initial={{ opacity: 0, x: 5 }}  
                whileInView={{ opacity: 1, x: -5 }}
                transition={{ duration: 0.5 }}>
                    <strong style={{ fontSize: '40px' }}>Ready to try Dreamvast?</strong>
                </motion.div>
                <motion.div
                initial={{ opacity: 0, x: 5 }}  
                whileInView={{ opacity: 1, x: -5 }}
                transition={{ duration: 0.5 }}>
                    <p>Click the button below or the <strong>Login</strong> button to try it out today!</p>
                </motion.div>
                <motion.div
                initial={{ opacity: 0, x: 5 }}  
                whileInView={{ opacity: 1, x: -5 }}
                transition={{ duration: 0.5 }}>
                    <a href={user && !error ? "/menu" : "/login"} className={styles.button}>
                    <RiLoginCircleLine size={30} color="#ffffff"/>
                    <span>{ user && !error ? "My Servers" : "Login" }</span>
                    </a>
                </motion.div>
            </div>
        </div>
    )
}